/**
 * A building type's name, without the indent the provider bakes into it.
 *
 * `BuildingTypesProvider` shapes its list for a flat `<option>` select: a parent that owns children is
 * emitted `disabled` as a pseudo-heading, and each child's label is prefixed with four U+00A0 so it looks
 * nested. That prefix is part of the label string, so anything else showing the name inherits an indent
 * it never asked for — which is exactly how the start-project dialog came to render the chosen building
 * type four spaces right of every other field.
 *
 * Shared so the knowledge of that prefix lives in one place. Two callers today: the dialog's optgroup
 * rebuild, and the setup summary in the wizard step rail (useProjectSetupSummary).
 */

/** The character the provider indents with (`BuildingTypesProvider.mapData`). */
// Written as an escape, not as a literal: a bare U+00A0 in source is invisible, so an editor or a
// paste normalising it to a plain space would silently stop the strip working with no visible diff.
export const BUILDING_TYPE_INDENT = "\u00A0";

export const buildingTypeDisplayLabel = (label: string): string => label.replaceAll(BUILDING_TYPE_INDENT, "").trim();

/** Whether the provider emitted this entry as a child of the row above it. */
export const isIndentedBuildingType = (label: string): boolean => label.startsWith(BUILDING_TYPE_INDENT);
